import { Router } from 'express';
import * as controller from './messages.controller';
import { authMiddleware } from '../../middleware/auth.middleware';

const router = Router();
router.use(authMiddleware);

router.get('/channel/:channelId/pinned', controller.pinnedChannelMessages);
router.get('/channel/:channelId', controller.channelMessages);

router.get('/conversation/:conversationId/pinned', controller.pinnedConversationMessages);
router.get('/conversation/:conversationId', controller.conversationMessages);

router.post('/', controller.create);
router.post('/broadcast/validate', controller.validateBroadcast);
router.post('/broadcast', controller.broadcast);
router.get('/broadcasts', controller.listBroadcasts);
router.delete('/broadcast/:broadcastId', controller.deleteBroadcast);
router.patch('/:id', controller.edit);
router.delete('/:id', controller.remove);
router.post('/:id/reactions', controller.react);
router.delete('/:id/reactions', controller.unreact);
router.get('/:id/thread', controller.thread);

router.post('/:id/pin', controller.pin);
router.delete('/:id/pin', controller.unpin);

export default router;
